//@flow
import { TOGGLE_MODAL } from './types';
import type { Node } from 'react';
import type { ButtonType } from '../components/button';

export type ModalAction = {
    text: string,
    handler: Function,
    type: ButtonType
} | null;

export const toggleModal = (content: ?Node,
    primaryAction: ?ModalAction = null,
    secondaryAction: ?ModalAction = null,
    footerContent: ?Node = null,
    warningContent: ?Node = null,
    thick: ?boolean, 
    options
    ) => ({
        type: TOGGLE_MODAL,
        payload: {
            content,
            primaryAction,
            secondaryAction,
            footerContent,
            warningContent,
            thick,
            options
        }
    });